import { useEffect, useState } from "react";

const TARGET = new Date("2026-11-27T00:00:00");

const getParts = () => {
  const diff = Math.max(0, TARGET.getTime() - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
    live: diff <= 0,
  };
};

const pad = (n) => String(n).padStart(2, "0");

const Cell = ({ value, label }) => (
  <div className="flex w-16 flex-col items-center sm:w-20">
    <span
      data-testid={`countdown-${label}`}
      className="font-display text-2xl font-bold tabular-nums tracking-tight sm:text-4xl"
    >
      {pad(value)}
    </span>
    <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
      {label}
    </span>
  </div>
);

export const CountdownTimer = () => {
  const [t, setT] = useState(getParts);

  useEffect(() => {
    const id = setInterval(() => setT(getParts()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      data-testid="countdown-section"
      className="border-t border-white/10 bg-white/[0.02] py-10"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 px-6 lg:flex-row lg:justify-between">
        <p className="text-center font-mono text-xs uppercase tracking-[0.35em] text-zinc-400 lg:text-left">
          {t.live ? "Black Friday is live — 50% off today" : "Black Friday starts in"}
        </p>
        <div className="flex items-start gap-4 sm:gap-8">
          <Cell value={t.days} label="days" />
          <span className="pt-1 font-display text-xl font-bold text-zinc-600 sm:text-3xl">:</span>
          <Cell value={t.hours} label="hrs" />
          <span className="pt-1 font-display text-xl font-bold text-zinc-600 sm:text-3xl">:</span>
          <Cell value={t.minutes} label="min" />
          <span className="pt-1 font-display text-xl font-bold text-zinc-600 sm:text-3xl">:</span>
          <Cell value={t.seconds} label="sec" />
        </div>
        <a
          href="#black-friday"
          data-testid="countdown-deal-link"
          className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-300 underline decoration-white/20 underline-offset-8 transition-colors duration-300 hover:text-white"
        >
          Code BFDAH — view deal
        </a>
      </div>
    </section>
  );
};
